import React, { useEffect, useState } from "react";
import "./Pagination.scss";
import { useContent } from "../../../contexts/contentContext/contentContext.js";

const Pagination = ({ maxPages, currentPage, setCurrentPage }) => {
  const { getDirection } = useContent();
  const [startPage, setStartPage] = useState(1);
  const [secondPage, setsecondPage] = useState(2);

  useEffect(() => {
    if (currentPage === 1) {
      setStartPage(1);
      setsecondPage(2);
    } else if (currentPage === maxPages) {
    } else {
      setsecondPage(currentPage + 1);
    }
  }, [currentPage]);

  // useEffect(() => {
  //   if (startPage > 2) {
  //     setsecondPage(startPage + 1);
  //   }
  // }, [startPage]);

  const nextPage = () => {
    if (currentPage !== maxPages) {
      setCurrentPage(currentPage + 1);
      setStartPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
      setStartPage(currentPage - 1);
    }
  };

  const listPages = () => {
    let temp = [];
    for (let i = 0; i < maxPages; i++) {
      const element = i;
      temp.push(element + 1);
    }
    if (maxPages > 5) {
      return (
        <>
          <span
            onClick={() => {
              setCurrentPage(1);
              setsecondPage(2);
            }}
            className={`number-page first-page ${
              currentPage === 1 ? "active" : ""
            }`}
          >
            {1}
          </span>

          {currentPage > 3 ? (
            <span onClick={() => {}} className={`number-page`}>
              ...
            </span>
          ) : null}

          {currentPage > 2 ? (
            <span
              onClick={() => {
                prevPage();
              }}
              className={`number-page prev-page`}
            >
              {currentPage - 1}
            </span>
          ) : null}

          {currentPage < maxPages && currentPage > 1 ? (
            <span
              onClick={() => {
                setCurrentPage(currentPage);
              }}
              className={`number-page ${"active"}`}
            >
              {currentPage}
            </span>
          ) : null}

          {currentPage < maxPages - 1 ? (
            <span
              onClick={() => {
                nextPage();
              }}
              className={`number-page next-page`}
            >
              {currentPage + 1}
            </span>
          ) : null}

          {currentPage < maxPages - 2 ? (
            <span onClick={() => {}} className={`number-page`}>
              ...
            </span>
          ) : null}
          <span
            onClick={() => {
              setCurrentPage(maxPages);
              setStartPage(maxPages - 1);
            }}
            className={`number-page last-page ${
              currentPage > maxPages - 1 ? "active" : ""
            }`}
          >
            {maxPages}
          </span>
        </>
      );
    } else {
      return temp.map((item, i) => (
        <span
          key={i}
          onClick={() => {
            setCurrentPage(item);
          }}
          className={`number-page ${currentPage === item ? "active" : ""}`}
        >
          {item}
        </span>
      ));
    }
  };

  return (
    <div className="Pagination-main">
      <span
        onClick={() => {
          currentPage > 1 ? prevPage() : setCurrentPage(currentPage);
        }}
        className={`pagination-arrow ${currentPage > 1 ? "" : "disable"}`}
      >
        <i
          className={`fas fa-angle-double-${
            getDirection() === "rtl" ? "right" : "left"
          }`}
        ></i>
      </span>
      {listPages()}
      <span
        onClick={() => {
          currentPage < maxPages ? nextPage() : setCurrentPage(currentPage);
        }}
        className={`pagination-arrow ${
          currentPage < maxPages ? "" : "disable"
        }`}
      >
        <i
          className={`fas fa-angle-double-${
            getDirection() === "rtl" ? "left" : "right"
          }`}
        ></i>
      </span>
    </div>
  );
};

export default Pagination;
